var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 20.572,
    viewBox: "0 0 32 20.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_541",
    "data-name": "Rect\\xE1ngulo 541",
    width: 32,
    height: 20.572,
    transform: "translate(0 0)",
    fill: "#20164d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_841",
    "data-name": "Grupo 841",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_840",
    "data-name": "Grupo 840",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1144",
    "data-name": "Trazado 1144",
    d: "M29.714,10.286a18.031,18.031,0,0,0-6.8-6.3,8,8,0,1,1-13.822,0,18.024,18.024,0,0,0-6.8,6.3c3.054,4.714,7.982,8,13.714,8s10.661-3.286,13.714-8M16.857,3.429A.869.869,0,0,0,16,2.572,5.45,5.45,0,0,0,10.571,8a.857.857,0,0,0,1.714,0A3.735,3.735,0,0,1,16,4.287a.869.869,0,0,0,.857-.857ZM32,10.286a2.464,2.464,0,0,1-.358,1.232A18.7,18.7,0,0,1,16,20.572,18.731,18.731,0,0,1,.358,11.518a2.3,2.3,0,0,1,0-2.464A18.734,18.734,0,0,1,16,0,18.731,18.731,0,0,1,31.642,9.054,2.477,2.477,0,0,1,32,10.286",
    fill: "#20164d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6f804a1ccabea6e8197a900a768eb454.svg";
export { ForwardRef as ReactComponent };